export default __webpack_public_path__ + "static/media/screen3.ce4c8127.png";